export * from './BankIcon'
